// src/components/OfferPromise.tsx
//
// What both sales pages promise parents, kept in one place so they always
// match the app (owner's decisions, 2026-10-20):
//   • the free first week   (the Learn area: Week 1 free for 7 days, no payment)
//   • the 14-day money-back guarantee (Payments: on the first payment for a child)
//   • the Parent Handbook's "Our Promise to You"
//   • the playbook prices (backend services/pricing.js)

import { Gift, HeartHandshake, ShieldCheck } from "lucide-react";

export const PRICE_NOTE =
  "Pay quarterly and save 10%, or yearly and save 20%. Two children: 10% off the second. Three or more: 15% off every child but the eldest.";

const ITEMS = [
  {
    icon: Gift,
    title: "Your first week is free",
    body: "Create your family account and open Week 1 for your child: every lesson, with tutor feedback, for 7 days. No payment, no card.",
  },
  {
    icon: ShieldCheck,
    title: "14-day money-back guarantee",
    body: "If it isn't right for your child, ask for a full refund within 14 days of your first payment, straight from your Payments page.",
  },
  {
    icon: HeartHandshake,
    title: "Our promise to you",
    body: "Every child who commits to this programme will leave with more capability, more confidence and more character than they arrived with. We don't promise every child will become a famous founder. We promise every child will become someone who builds things, speaks clearly, thinks honestly about money and serves others with their skills.",
  },
];

export default function OfferPromise({ dark = false }: { dark?: boolean }) {
  return (
    <div className="grid gap-4 md:grid-cols-3">
      {ITEMS.map(({ icon: Icon, title, body }) => (
        <div
          key={title}
          className={`rounded-[24px] p-6 ${dark ? "bg-white/10 text-white ring-1 ring-white/15" : "bg-white text-ink ring-1 ring-[#e5e8ef]"}`}
        >
          <span className={`flex h-11 w-11 items-center justify-center rounded-2xl ${dark ? "bg-white/15" : "bg-gold-100"}`}>
            <Icon className={`h-6 w-6 ${dark ? "text-gold-300" : "text-gold-500"}`} />
          </span>
          <p className="mt-4 text-[17px] font-extrabold">{title}</p>
          <p className={`mt-2 text-[15px] leading-7 ${dark ? "text-white/80" : "text-ink-soft"}`}>{body}</p>
        </div>
      ))}
    </div>
  );
}
